import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/api';

export default function UserViewPage() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await api.get(`/users`);
        const foundUser = data.users.find(u => u.id === parseInt(userId));
        setUser(foundUser);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  if (loading) return <div className="page-content">Loading user details...</div>;
  if (!user) return <div className="page-content">User not found.</div>;

  return (
    <div className="page-content">
      <div className="admin-header">
        <div>
          <h2>User Profile</h2>
          <p>Detailed information for {user.name || user.email}</p>
        </div>
        <button className="btn-secondary" onClick={() => navigate('/admin')}>Back to Admin</button>
      </div>

      <div className="admin-content-card" style={{ padding: '2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          <div className="detail-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>FULL NAME</label>
            <div style={{ fontSize: '1.1rem', fontWeight: 600 }}>{user.name || '—'}</div>
          </div>
          <div className="detail-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>EMAIL ADDRESS</label>
            <div style={{ fontSize: '1.1rem', fontWeight: 600 }}>{user.email}</div>
          </div>
          <div className="detail-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>ROLE</label>
            <div>
              <span className="tag-pill" style={{ background: '#f1f5f9', color: '#475569', fontWeight: 600 }}>
                {user.role}
              </span>
            </div>
          </div>
          <div className="detail-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>ACCOUNT STATUS</label>
            <div>
              <span className={`status-badge ${user.is_active ? 'active' : 'inactive'}`}>
                {user.is_active ? '● Active' : '● Inactive'}
              </span>
            </div>
          </div>
          <div className="detail-group">
            <label style={{ fontWeight: 700, color: '#64748b', fontSize: '0.85rem', display: 'block', marginBottom: '0.5rem' }}>JOINED DATE</label>
            <div style={{ fontSize: '1.1rem' }}>{new Date(user.created_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</div>
          </div>
        </div>
        
        <div style={{ marginTop: '3rem', borderTop: '1px solid #f1f5f9', paddingTop: '1.5rem', display: 'flex', gap: '1rem' }}>
          <button className="btn-primary" onClick={() => navigate(`/admin/users/edit/${user.id}`)}>Edit Profile</button>
        </div>
      </div>
    </div>
  );
}

